import { Iterable } from 'immutable';

export function canConvertToJS(target) {
  return Iterable.isIterable(target) && typeof target.toJS === 'function';
}
